import { withTranslation } from "next-i18next";
import Button from "@components/core/Button";
import shouldHideFilterSectionInListingPage from "@utils/catalog-filters/shouldHideFilterSectionInListingPage";

function QuickFilterButton({
  filterSectionKey,
  checkedFilters,
  quickFilterButtonsOrder,
  openSection,
  showSelectedValues = false,
  hideOnInactive = false,
  hideCount = false,
  alternativeTitle,
  listingPage,
  filtersConflictingWithListingPage = [],
  items = [],
  t,
}) {
  const order = quickFilterButtonsOrder[filterSectionKey];
  const sectionCheckedFilters = checkedFilters[filterSectionKey] || [];
  const isActiveFilter = sectionCheckedFilters.length;

  if (hideOnInactive && !isActiveFilter) return null;
  if (items?.length < 2 && !isActiveFilter) return null;
  if (
    filtersConflictingWithListingPage.some((filterKey) =>
      shouldHideFilterSectionInListingPage(listingPage, filterKey),
    )
  ) {
    return null;
  }

  const btnTitle = t(`catalog:filters.section_titles.${alternativeTitle || filterSectionKey}`);

  const btnText = () => {
    if (showSelectedValues && isActiveFilter) {
      return sectionCheckedFilters
        .map((filter) => t(`catalog:filters.${filterSectionKey}.${filter?.label || filter}`))
        .join(", ");
    }

    return `${btnTitle}${isActiveFilter && !hideCount ? ` (${sectionCheckedFilters.length})` : ""}`;
  };

  return (
    <Button
      variant={isActiveFilter ? "middle-primary" : "outline-primary"}
      size="sm"
      pill
      onClick={() => openSection(filterSectionKey)}
      trackingName="filterButton"
      title={btnTitle}
      style={{ order }}
      hugContent
    >
      {btnText()}
    </Button>
  );
}

export default withTranslation("catalog")(QuickFilterButton);
